interface AppointmentEmptyProps extends React.ComponentPropsWithoutRef<"div"> {
  title: string
  message: string
}

const AppointmentEmpty = ({ title, message, children }: AppointmentEmptyProps) => {
  return (
    <div className="grid h-full content-center items-center justify-center gap-4 p-4 text-center">
      <div className="grid gap-1">
        <h2 className="text-on-surface text-xl font-bold" data-testid="clear-filters-title">
          {title}
        </h2>
        <span className="text-on-surface-subdued text-base" data-testid="clear-filters-message">
          {message}
        </span>
      </div>
      {children}
    </div>
  )
}
export { AppointmentEmpty }
